import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import { IEditDTO } from "../../services/setpoint-administration-service/Models";
import SetpointAdministrationService from "../../services/setpoint-administration-service/SetpointAdministrationService";
import {keys as alarmSchemeKeys} from "../alarm-scheme-admin/Keys";

export type MutationContextType = {
    previous: IEditDTO | undefined;
};

export type UseSaveSetpointParameters = {
    groupID: number,
    organizationID: number
} & BaseUseMutationParameters<IEditDTO, IEditDTO>;

export function useSaveSetpoint({
    groupID,
    organizationID,
    onError,
    onSuccess
}: UseSaveSetpointParameters) {
    const queryClient = useQueryClient();

    return useMutation<IEditDTO, RestError, IEditDTO, MutationContextType>(
        (setpoint) => {
            return SetpointAdministrationService.saveSetpoint(
                groupID,
                setpoint
            );
        },
        {
            onMutate: async (item: IEditDTO) => {

                await queryClient.cancelQueries(keys.all);

                queryClient.invalidateQueries({
                    queryKey: [keys.all, alarmSchemeKeys.all],
                    active: true,
                    inactive: true
                    //type: 'all'
                });

                queryClient.refetchQueries({
                    //queryKey: [keys.all],
                    queryKey: [
                        keys.setPoints, 
                        keys.groupedSetPoints, 
                        keys.referenceData, 
                        alarmSchemeKeys.alarmSchemes, 
                        alarmSchemeKeys.getAlarmScheme, 
                        alarmSchemeKeys.referenceData
                    ],
                    active: true,
                    inactive: true
                    //type: 'all'
                });

                if (item.setPointID > 0) {
                    queryClient.setQueryData<IEditDTO>(keys.getSetpoint(groupID, item.setPointID, organizationID), item);
                }

                const prev = queryClient.getQueryData<IEditDTO>(keys.getSetpoint(item.setPointID, groupID, item.organizationID));

                return {
                    previous: prev ?? item
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            // onSettled: (_data, error, _configuration, context) => {

            //     // const otherKeys = _configuration.pageConfigurationType === PageConfigurationTypeEnum.SummaryListing_RTS ?
            //     // deviceSummaryKeys :
            //     // wellSummaryKeys;                

            //     // if (error && context?.previousConfigurations) {

            //     //     queryClient.setQueryData<PageConfigurationDataModel3>(
            //     //         otherKeys.configurationList(
            //     //             groupID
            //     //         ),
            //     //         context?.previousConfigurations
            //     //     );
            //     // }

            //     // // If there was an error in saving our configuration, such as name in use,
            //     // // then don't invalidate the queries, otherwise the configuration will
            //     // // reload and our changes will be discarded.
            //     // if (!error) {
            //     //     queryClient.invalidateQueries(keys.all);
            //     //     queryClient.invalidateQueries(otherKeys.all);
            //     // }
            // }
        }
    );
}
